import { CampaignDto } from '@/Domain/api/Action/dto/Campaign.dto';
import { CampaignBox } from '@/Domain/components/Action/CampaignAction/CampaignBox';
import { HandoffActionBox } from '@/Domain/components/Action/HandoffAction/HandoffActionBox';

type Props = {
  campaigns: CampaignDto[];
};

export const AppActionsList = ({ campaigns }: Props) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
    <HandoffActionBox />
    {campaigns.map((campaign) => (
      <CampaignBox key={campaign.id} campaign={campaign} />
    ))}
  </div>
);
